import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {FITHGameAssets} from "../FITHGameAssets";
import {FITHGameConfig} from "../FITHGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FITHParsedInitData} from "../server/data/FITHParsedInitData";
import {FITHParsedGameData} from "../server/data/FITHParsedGameData";
import {FITHSoundManager} from "../sound/FITHSoundManager";
import {FITHSoundConfig} from "../FITHSoundConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";

export class FITHBonusGameVSymOverlayView extends BaseView {
    private _layer: ScalableLayer;
    private _landAnimations: PIXI.spine.Spine[] = [];
    private _vOverlayBgItems: PIXI.Sprite[] = [];
    private _vOverlayHighlightItems: TimelineSprite[] = [];
    private _bonusValuesBeforeSpin: number[][] = [];
    private _bonusValues: number[][] = [];
    private _dwarfPosition: number[] = [];
    private _reels: string[][] = [];
    private _bonusNewPositions: boolean[][] = [];
    private _resourcesLoaded: boolean = false;
    private _bottomCollectorActivated: boolean[];
    private _bottomCollectorsSoundsPlayed: boolean = false;
    private _coinLandingSoundPlayed: boolean = false;
    private _fsDwarfSoundSwitched: boolean = false;
    private _fsDwarfCoinLandedSoundPlayed: boolean = false;
    private _fsMultiToDwarfSoundPlayed: boolean = false;
    private _fsChestCoinLandedSoundPlayed: boolean = false;

    // #345
    private _multiOnCoinApplied: boolean[] = [];

    private _vOverlayItems: PIXI.Sprite[] = [];
    get vOverlayItems(): PIXI.Sprite[] {
        return this._vOverlayItems;
    }

    private _dOverlayItems: PIXI.Sprite[][] = [];
    get dOverlayItems(): PIXI.Sprite[][] {
        return this._dOverlayItems;
    }

    private _bottomRowWagons: PIXI.spine.Spine[] = [];
    get bottomRowWagons(): PIXI.spine.Spine[] {
        return this._bottomRowWagons;
    }

    private _isAborted: boolean = false; // #284, #297
    set isAborted(value: boolean) {
        this._isAborted = value;
    }

    private static createMultiplierItem(text: string): BitmapCountUp {
        const xOffset: number = 4,
            multiplierItem = new BitmapCountUp({
                style: {
                    font: {
                        name: "NumbersFSMulti",
                        size: 22
                    },
                    tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                }
            });

        multiplierItem.name = "1xCoin";
        multiplierItem.position.set(-xOffset, 0);
        multiplierItem.text = text;
        multiplierItem.pivot.set(multiplierItem.width / 2, multiplierItem.height / 2);

        // #296
        if (text === "1") {
            multiplierItem.alpha = 0.8;
        }

        return multiplierItem;
    }

    // #304
    private static playFSCoinLandingSound(landingValue: number): void {
        if (landingValue === 1) {
            FITHSoundManager.playFSCoinLandingTiny();
        } else if (landingValue > 1 && landingValue < 50) {
            FITHSoundManager.playFSCoinLandingSmall();
        } else if (landingValue > 49 && landingValue < 300) {
            FITHSoundManager.playFSCoinLandingMedium();
        } else if (landingValue > 299) {
            FITHSoundManager.playFSCoinLandingLarge();
        }
    }

    public exitFS(idx: number): void {
        this._vOverlayBgItems[idx].visible = false;
        this._vOverlayItems[idx].visible = false;
        this._vOverlayItems[idx].children.forEach((child: PIXI.DisplayObject) => {
            if (child instanceof PIXI.spine.Spine) {
                child.state.clearTracks();
                child.skeleton.setToSetupPose();
                child.skeleton.setSlotsToSetupPose();
            }
        });
        this._vOverlayItems[idx].removeChildren();

        this._fsDwarfSoundSwitched = false;
        this._fsDwarfCoinLandedSoundPlayed = false;

        // #345
        this._multiOnCoinApplied = ArrayHelper.initArrayWithValues(FITHGameConfig.instance.REELS_NUM, () => false);
    }

    public toggleDOverlaySymbol(reelId: number, symId: number, visible: boolean): void {
        this._dOverlayItems[reelId][symId - 3].visible = visible;
    }

    public toggleBottomRowWagon(idx: number, visible: boolean): void {
        const wagon: PIXI.spine.Spine = this._bottomRowWagons[idx],
            bottomRowMultiplierItem: BitmapCountUp = (wagon.getChildByName("totalMulti") as BitmapCountUp);

        bottomRowMultiplierItem.visible = false;
        bottomRowMultiplierItem.text = "";
        if (!visible) {
            wagon.visible = false;
            wagon.state.clearTracks();

            this._bottomCollectorActivated = []; // reset it
        } else {
            if (this._bottomCollectorActivated[idx]) {
                const val: number = this._bonusValues[idx][5];
                if (val > 0) {
                    bottomRowMultiplierItem.text = val + "x";
                    bottomRowMultiplierItem.pivot.set(bottomRowMultiplierItem.width / 2, bottomRowMultiplierItem.height / 2);
                    bottomRowMultiplierItem.visible = true;
                    this.updateBottomRowWagonSkin(wagon, val);
                    this.updateStateForBottomChestWagon(wagon, "active", true);
                } else {
                    this.setBottomRowWagonToLv0(wagon, "active", true);
                }
            } else {
                this.setBottomRowWagonToLv0(wagon, "lock", false);
            }

            wagon.updateTransform();
            wagon.visible = true;
        }
    }

    public updateBottomRowWagon(idx: number): void {
        const wagon: PIXI.spine.Spine = this._bottomRowWagons[idx];
        this.updateStateForBottomChestWagon(wagon, "unlock", false);
        TweenLite.delayedCall(wagon.spineData.findAnimation("unlock").duration, () => this.setBottomRowWagonToLv0(wagon, "active", true));
    }

    public toggleHighlightSlot(reelId: number, on: boolean): void {
        const item: TimelineSprite = this._vOverlayHighlightItems[reelId];
        if (on) {
            item.playLoop();
            item.show();
        } else if (item.visible) {
            item.stopLoop();
            item.hide();
        }
    }

    public highlightAllV(): TimelineLite {
        let item: PIXI.Sprite,
            bgItem: PIXI.Sprite,
            tl: TimelineLite = new TimelineLite();

        for (let i: number = 0; i < this._vOverlayItems.length; i++) {
            bgItem = this._vOverlayBgItems[i];
            item = this._vOverlayItems[i];
            if (item.visible && item.scale.x !== 1) {
                tl.to([bgItem.scale, item.scale], 0.5, {x: 1, y: 1}, 0);
            }
        }

        return tl;
    }

    public dimAllV(): void {
        let item: PIXI.Sprite,
            bgItem: PIXI.Sprite,
            toScale: number;
        for (let i: number = 0; i < this._vOverlayItems.length; i++) {
            bgItem = this._vOverlayBgItems[i];
            item = this._vOverlayItems[i];

            if (item.visible) {
                if (item.name === "notCoin") {
                    toScale = 0.9;
                } else {
                    toScale = 0.8;
                }
                TweenLite.to([bgItem.scale, item.scale], 0.5, {x: toScale, y: toScale});
            }
        }

        // #284, #297
        this._bottomCollectorsSoundsPlayed = false;
        this._isAborted = false;
        // #300
        this._coinLandingSoundPlayed = false;

        this._fsMultiToDwarfSoundPlayed = false;
        this._fsChestCoinLandedSoundPlayed = false;

        this._bonusValuesBeforeSpin = [...this._bonusValues];

        // #345
        this._multiOnCoinApplied = ArrayHelper.initArrayWithValues(FITHGameConfig.instance.REELS_NUM, () => false);
    }

    public animateAllV(allVIndex: number[], wagonX: number, wagonY: number, newVId: number): void {
        const tl: TimelineLite = new TimelineLite();
        let vSym: PIXI.Sprite,
            vBg: PIXI.Sprite,
            effGlow: PIXI.Sprite,
            vScreen: PIXI.Sprite;

        for (let i: number = 0; i < allVIndex.length; i++) {
            // #240
            if (i === 0) {
                tl.add(() => FITHSoundManager.playFSCoinHighlight(), 3 / 30);
            }

            tl.add(() => {
                effGlow = new PIXI.Sprite(GameResources.getTextures("effGlow1")[0]);
                effGlow.alpha = 0;
                effGlow.anchor.set(0.5);
                effGlow.blendMode = PIXI.BLEND_MODES.SCREEN;

                vBg = this._vOverlayBgItems[allVIndex[i]];
                vSym = this._vOverlayItems[allVIndex[i]];
                this.turnOffVSymLand(vSym);

                vSym.addChildAt(effGlow, 0);
                TweenLite.to(effGlow, 2 / 30, {alpha: 1});

                if (vSym.name === "coin") {
                    vScreen = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures("V")[0]);
                    vScreen.alpha = 0;
                    vScreen.anchor.set(0.5);
                    vScreen.blendMode = PIXI.BLEND_MODES.SCREEN;
                    vSym.addChild(vScreen);
                    TweenLite.to(vScreen, 10 / 30, {alpha: 1, delay: 7 / 30});
                }

                TweenLite.to([vBg.scale, vSym.scale], 2 / 30, {x: 1.1, y: 1.1});
                TweenLite.to([vBg.scale, vSym.scale], 20 / 30, {x: 1.2, y: 1.2, delay: 2 / 30});
                TweenLite.to([vBg.scale, vSym.scale], 5 / 30, {x: 0.5, y: 0.5, delay: 22 / 30});

                TweenLite.to([vBg, vSym], 5 / 30, {x: wagonX, y: wagonY, delay: 22 / 30});

                TweenLite.to([vBg, vSym], 0, {alpha: 0, delay: 27 / 30});

                if (i % 4 === 0) {
                    TweenLite.delayedCall(25 / 30, () => FITHSoundManager.playFSCoinSweep());
                }
            }, ((i + 1) * 3) / 30);

            // #334
            if (allVIndex[i] !== newVId && allVIndex[i] !== (this._dwarfPosition[0] * 6)) {
                // #140
                Reels.getSymbol(allVIndex[i], 0)?.replaceWith("X", allVIndex[i]);
                FITHGameModuleConfig.spinController.enableBonusReel(allVIndex[i]);
            }
        }
    }

    public changeVSymToBagOrChest(newVId: number, newTextureName: string, multiplierValue: number): void {
        const vSym: PIXI.Sprite = this._vOverlayItems[newVId],
            multiplierItem: BitmapCountUp = (vSym.getChildByName("1xCoin") as BitmapCountUp);
        let bgTexture: PIXI.Texture;

        if (newTextureName[0] === "g") { // checking if it is g2Open or rBag
            bgTexture = GameResources.getTextures("gBg")[0];
        } else {
            bgTexture = GameResources.getTextures("rBg")[0];
        }

        this.resetVSym(vSym, newVId, GameResources.getTextures(newTextureName)[0]);
        this.removeVSymChildren(vSym);
        this.checkForVBg(multiplierItem, multiplierValue, vSym, newVId, bgTexture);
        vSym.name = "notCoin";

        multiplierItem.text = (multiplierValue + "x");
        multiplierItem.pivot.set(multiplierItem.width / 2, multiplierItem.height / 2);
        vSym.addChild(multiplierItem);
    }

    public applyMultiAnimation(idx: number, multiplier: string): void {
        // #345
        if (this._multiOnCoinApplied[idx]) {
            return;
        }
        this._multiOnCoinApplied[idx] = true;

        const item: PIXI.Sprite = this._vOverlayItems[idx],
            multiSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("V_spine"));

        let multiplierItem: BitmapCountUp = (item.getChildByName("1xCoin") as BitmapCountUp),
            tween: SpineTween;

        // #287, safe check, although it's not reproducible.
        if (multiplierItem === null) {
            const coinValue: number = this._bonusValuesBeforeSpin[Math.floor((idx / 6))][(idx % 6)];
            multiplierItem = FITHBonusGameVSymOverlayView.createMultiplierItem((coinValue ? coinValue + "" : ""));
        }

        this.turnOffVSymLand(item);

        item.visible = true;
        // #229
        if (multiplier !== "1" && item.name === "coin") {
            item.addChild(multiSpine);
            tween = new SpineTween(multiSpine, 0, "multi");
            tween.eventCallback("onComplete", () => item.removeChild(multiSpine));
        }

        let multiplyBy: number;
        if (multiplierItem.text) {
            multiplyBy = parseInt(multiplierItem.text.split("x")[0]);
        } else {
            multiplyBy = 1;
        }
        const multiValue: number = (multiplyBy * parseInt(multiplier));

        // #199
        if (multiValue === 1) {
            item.texture = GameResources.getTextures(FITHGameAssets.getSymbolStateTexturePath("V") + "_brown")[0];
        } else if (item.name === "coin") { // #229
            item.texture = FITHGameAssets.getSymbolStateTextures("V")[0];
        }
        this.checkForVBg(multiplierItem, multiValue, item, idx, GameResources.getTextures("vBg")[0]);

        // #296
        if (multiValue === 1) {
            multiplierItem.alpha = 0.8;
        } else {
            multiplierItem.alpha = 1;
        }

        multiplierItem.text = (multiValue + "x");
        multiplierItem.pivot.set(multiplierItem.width / 2, multiplierItem.height / 2);
        item.addChild(multiplierItem);

        TweenLite.to(multiplierItem.scale, 5 / 30, {x: 1.5, y: 1.5});
        TweenLite.to(multiplierItem.scale, 4 / 30, {x: 1, y: 1, delay: 5 / 30});
    }

    public applyMultiAnimationForGoldBar(idx: number, multiplier: string, wagonId: number, loopCount: number): void {
        const effGlow2: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("effGlow2")[0]),
            yPos: number = Helper.getSymbolPositions(wagonId, 2)[1] + (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME / 2);

        // #317
        if ((this._dwarfPosition[0] === Math.floor((idx / 6))) && (this._dwarfPosition[1] === (idx % 6))) {
            FITHGameModuleConfig.bonusGameSpinNWagonAnimations.animateDwarfMultiplierForGoldBar(parseInt(multiplier));
        } else {
            this.applyMultiAnimation(idx, multiplier);
        }

        if (loopCount === 0) {
            effGlow2.scale.set(1, 4);
            effGlow2.anchor.set(0.5);
            effGlow2.blendMode = PIXI.BLEND_MODES.SCREEN;
            effGlow2.position.set(this._vOverlayItems[idx].x, yPos);
            effGlow2.alpha = 0;

            this._layer.addChildAt(effGlow2, 0);

            TweenLite.to(effGlow2, 2 / 30, {alpha: 1});
            TweenLite.to(effGlow2, 5 / 30, {
                alpha: 0,
                onComplete: () => this._layer.removeChild(effGlow2)
            });
        }
    }

    public triggerLandAnimation(reelId: number, doFast: boolean): void {
        const wagonId: number = Math.floor((reelId / 6)), // converting to 0 - 5 only, as wagonId is maintained like this
            reel: string[] = this._reels[(wagonId * 6)]; // converting to 0, 6, 12, 18, 24, 30 only, as wagons in reels object lies on these positions

        // #334
        if (!this._bonusNewPositions[wagonId][(reelId % 6)]) {
            return;
        }

        Reels.getSymbol(reelId, 0)!.setVisibility(false); // hide original reel symbol.

        const landAnimation: PIXI.spine.Spine = this._landAnimations[reelId],
            multiplier: string = reel[0].split("C")[1];

        landAnimation.state.clearTracks();
        landAnimation.skeleton.setSkin(null);

        // #221
        if (multiplier === "1") {
            landAnimation.skeleton.setSkinByName("brown");
        } else {
            landAnimation.skeleton.setSkinByName("gold");
        }

        landAnimation.skeleton.setToSetupPose();
        landAnimation.skeleton.setSlotsToSetupPose();
        landAnimation.state.setEmptyAnimation(0, 0);
        new SpineTween(landAnimation, 0, "land").timeScale((doFast ? 5 : 1));
        landAnimation.updateTransform();
        landAnimation.visible = true;

        FITHGameModuleConfig.bonusGameSpinNWagonAnimations.brightWagon(wagonId);

        // as per #44
        TweenLite.delayedCall(12 / 30, () => this.show1xOnCoinSymbol(reelId, multiplier)).timeScale((doFast ? 5 : 1));

        // #290
        if (reel[0] === "DW") {
            if (!this._fsDwarfSoundSwitched) {
                this._fsDwarfSoundSwitched = true;
                FITHSoundManager.switchFSToFSDwarf();
            }

            // #298
            FITHGameModuleConfig.anticipationView.stopWagonAnticipationCurrentReel(wagonId);

            // #312
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_DWARF_ANTICIPATION);

            // #313
            if (!this._fsDwarfCoinLandedSoundPlayed) {
                this._fsDwarfCoinLandedSoundPlayed = true;
                FITHSoundManager.playFSCoinLandingDwarf();
            }
        }
        // #298
        else if (reel[0] === "G") {
            FITHGameModuleConfig.anticipationView.stopWagonAnticipationCurrentReel(wagonId);

            // #312
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_CHEST_ANTICIPATION);

            // #313
            if (!this._fsChestCoinLandedSoundPlayed) {
                this._fsChestCoinLandedSoundPlayed = true;
                FITHSoundManager.playFSCoinLandingChest();
            }
        }
        else {
            // #298
            if (reel[0] === "C100") {
                FITHGameModuleConfig.anticipationView.stopWagonAnticipationCurrentReel(wagonId);

                // #312
                FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_DWARF_ANTICIPATION);
            }
            else if (reel[0] === "X25") {
                FITHGameModuleConfig.anticipationView.stopWagonAnticipationCurrentReel(wagonId);

                // #312
                FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.FS_DWARF_ANTICIPATION);
            }

            // #240
            if (!doFast) {
                // #304, the calculation.
                let landingMulti: number = 1; // default is for bag, it will always add only 1 in that reel.
                // C wagons i.e coin wagons
                if (multiplier) {
                    landingMulti = parseInt(multiplier);
                } else if (reel[0].split("X")[1]) { // X wagons i.e reel multipliers
                    landingMulti = parseInt(reel[0].split("X")[1]);
                    let beforeValues: number[] = this._bonusValuesBeforeSpin[wagonId],
                        dwarfPosition: number[] = this._dwarfPosition,
                        totalBeforeValue: number = 0,
                        totalAfterValue: number = 0;
                    for (let i: number = 1; i < this._bonusValuesBeforeSpin[wagonId].length - 1; i++) {
                        if (wagonId !== dwarfPosition[0] || i !== dwarfPosition[1]) {
                            totalBeforeValue += beforeValues[i];

                            totalAfterValue += (beforeValues[i] * landingMulti);
                        }
                    }
                    landingMulti = ((totalAfterValue + landingMulti) - totalBeforeValue);
                } else if (reel[0].split("B")[1]) { // B wagons i.e dynamites
                    landingMulti = parseInt(reel[0].split("B")[1]);
                }

                FITHBonusGameVSymOverlayView.playFSCoinLandingSound(landingMulti);
            } else if (doFast && !this._coinLandingSoundPlayed) { // #300
                this._coinLandingSoundPlayed = true;
                // #304
                this.playFSCoinLandingMostValuable();
            }
        }
    }

    public turnOffVSymLandForV(idx: number): void {
        this.turnOffVSymLand(this._vOverlayItems[idx]);
    }

    public animateItemsForBottomCollector(container: PIXI.Container, wagonId: number, totalMultiplierValue: number): TimelineLite {
        const bottomRowWagon: PIXI.spine.Spine = this._bottomRowWagons[wagonId],
            startVSymId: number = ((wagonId * 6) + 1),
            endVSymId: number = (startVSymId + 4),
            activeCoins: number[] = [],
            tl: TimelineLite = new TimelineLite();

        for (let i: number = startVSymId; i < endVSymId; i++) {
            if (this._vOverlayItems[i].alpha === 1 && this._vOverlayItems[i].getChildByName("1xCoin")) {
                activeCoins.push(i);
            }
        }

        // #176, #336
        if (totalMultiplierValue > 0) {
            tl.add(() => this.updateStateForBottomChestWagon(bottomRowWagon, "start", false), 0);

            tl.add(() => {
                // #240, #284, #297
                if (!this._isAborted) {
                    FITHSoundManager.playFSCoinHighlight();
                } else if (this._isAborted && !this._bottomCollectorsSoundsPlayed) {
                    FITHSoundManager.playFSCoinHighlight();
                }

                for (let i: number = 0; i < activeCoins.length; i++) {
                    let vSym: PIXI.Sprite = this._vOverlayItems[activeCoins[i]];
                    const endScale: PIXI.IPoint = vSym.scale;

                    TweenLite.to(vSym.scale, 2 / 30, {x: 1.1, y: 1.1});
                    TweenLite.to(vSym.scale, 15 / 30, {x: 1.2, y: 1.2, delay: 2 / 30});
                    TweenLite.to(vSym.scale, 10 / 30, {x: endScale.x, y: endScale.y, delay: 17 / 30});

                    if (vSym.name === "coin" && (vSym.getChildByName("1xCoin") as BitmapCountUp).text !== "1x") {
                        TweenLite.delayedCall(7 / 30, () => {
                            let vSymScreen: PIXI.Sprite = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures("V")[0]);
                            vSymScreen.blendMode = PIXI.BLEND_MODES.SCREEN;
                            vSymScreen.alpha = 0;
                            vSymScreen.anchor.set(0.5);
                            vSym.addChild(vSymScreen);
                            TweenLite.to(vSymScreen, 10 / 30, {alpha: 1});
                            TweenLite.to(vSymScreen, 4 / 30, {alpha: 0, delay: 10 / 30});
                        });
                    }
                    TweenLite.delayedCall(17 / 30, () => {
                        let multiItem: BitmapCountUp = new BitmapCountUp({
                            style: {
                                font: {
                                    name: "NumbersFSMulti",
                                    size: 18
                                },
                                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                            }
                        });

                        multiItem.text = (vSym.getChildByName("1xCoin") as BitmapCountUp).text;
                        multiItem.position.set(vSym.x - 4, vSym.y + 10);
                        multiItem.pivot.set(multiItem.width / 2, multiItem.height / 2);
                        container.addChild(multiItem);
                        TweenLite.to(multiItem, 10 / 30, {y: bottomRowWagon.y + 10});
                        TweenLite.to(multiItem, 0, {alpha: 0, delay: 10 / 30});
                    });
                }
            }, 3 / 30);

            // #240
            tl.add(() => {
                // #284, #297
                if (!this._isAborted) {
                    FITHSoundManager.playFSMultiDownToChest();
                } else if (this._isAborted && !this._bottomCollectorsSoundsPlayed) {
                    FITHSoundManager.playFSMultiDownToChest();
                }
            }, 20 / 30);

            tl.add(() => {
                let totalMultiItem: BitmapCountUp = (bottomRowWagon.getChildByName("totalMulti") as BitmapCountUp);
                totalMultiItem.scale.set(1.1);
                totalMultiItem.text = (totalMultiplierValue + "x");
                totalMultiItem.pivot.set(totalMultiItem.width / 2, totalMultiItem.height / 2);

                if (!totalMultiItem.visible) {
                    totalMultiItem.visible = true;
                }
                TweenLite.to(totalMultiItem.scale, 5 / 30, {x: 1.3, y: 1.3});
                TweenLite.to(totalMultiItem.scale, 10 / 30, {x: 1, y: 1, delay: 5 / 30});

                this.updateStateForBottomChestWagon(bottomRowWagon, "end", false);
                TweenLite.delayedCall(bottomRowWagon.spineData.findAnimation("end").duration, () => {
                    // #180
                    if (bottomRowWagon.state.getCurrent(0).animation.name !== "dark") {
                        this.updateStateForBottomChestWagon(bottomRowWagon, "active", true);
                    }
                });

                this.updateBottomRowWagonSkin(bottomRowWagon, totalMultiplierValue);

                // #240, #284, #297
                if (!this._isAborted) {
                    FITHSoundManager.playFSMultiLandsInChest();
                } else if (this._isAborted && !this._bottomCollectorsSoundsPlayed) {
                    this._bottomCollectorsSoundsPlayed = true;
                    FITHSoundManager.playFSMultiLandsInChest();
                }
            }, 1);

            tl.add(TweenLite.to({}, 15 / 30, {}), 1); // so that the above gets finished properly.
        }

        return tl;
    }

    // #180
    public toggleDarkStateForBottomCollectors(): void {
        let wagon: PIXI.spine.Spine;
        for (let i: number = 0; i < this._bottomRowWagons.length; i++) {
            wagon = this._bottomRowWagons[i];
            if (wagon.state.getCurrent(0).animation.name === "active" || wagon.state.getCurrent(0).animation.name === "end") {
                this.updateStateForBottomChestWagon(wagon, "dark", false);
                wagon.getChildByName("totalMulti").alpha = 0.6;
            } else if (wagon.state.getCurrent(0).animation.name === "dark") {
                this.updateStateForBottomChestWagon(wagon, "active", true);
                wagon.getChildByName("totalMulti").alpha = 1;
            }
        }
    }

    public animateItemsForDwarfCollector(container: PIXI.Container, allVIndex: number[], wagonX: number, wagonY: number): void {
        const tl: TimelineLite = new TimelineLite();

        let vSym: PIXI.Sprite,
            multiItem: BitmapCountUp;

        // #240
        if (allVIndex.length > 0) {
            tl.add(() => FITHSoundManager.playFSCoinHighlight(), 0);
        }

        for (let i: number = 0; i < allVIndex.length; i++) {
            tl.add(() => {
                vSym = this._vOverlayItems[allVIndex[i]];

                if (vSym.getChildByName("1xCoin")) {
                    multiItem = new BitmapCountUp({
                        style: {
                            font: {
                                name: "NumbersFSMulti",
                                size: 18
                            },
                            tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                        }
                    });
                    multiItem.text = ((vSym.getChildByName("1xCoin") as BitmapCountUp).text);
                    multiItem.scale.set(2);
                    multiItem.position.set(vSym.x - 4, vSym.y + 30);
                    multiItem.pivot.set(multiItem.width / 2, multiItem.height / 2);

                    container.addChild(multiItem);

                    TweenLite.to(multiItem, 5 / 30, {x: wagonX - 25, y: wagonY + 25});
                    TweenLite.to(multiItem, 0, {alpha: 0, delay: 5 / 30});

                    // #240, #321
                    if (!this._isAborted) {
                        FITHSoundManager.playFSMultiToDwarf();
                    } else if (this._isAborted && !this._fsMultiToDwarfSoundPlayed) {
                        this._fsMultiToDwarfSoundPlayed = true;
                        FITHSoundManager.playFSMultiToDwarf();
                    }
                }
            }, ((i * 3) / 30));
        }
    }

    public resetVSym(vSym: PIXI.Sprite, id: number, texture: PIXI.Texture): void {
        const hlSlot: PIXI.Sprite = this._vOverlayHighlightItems[id];

        vSym.position.set(hlSlot.x, hlSlot.y);
        vSym.texture = texture;
        vSym.visible = true;
        vSym.alpha = 1;
        vSym.scale.set(1);
    }

    public removeVSymChildren(vSym: PIXI.Sprite): void {
        vSym.children.forEach((child: PIXI.DisplayObject) => {
            if (child instanceof PIXI.spine.Spine) {
                child.state.clearTracks();
                child.skeleton.setToSetupPose();
                child.skeleton.setSlotsToSetupPose();
            }
        });
        vSym.removeChildren();
    }

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        this._layer = StageManager.getLayer(FITHGameConfig.instance.LAYERS.BONUS_OVERLAY_V_SYMBOLS.name);
        this._layer.addChild(this);

        this.createOverlayDSymbolsGrid();
        this.createLandAnimations();
        this.createOverlaySymbolsGrid();
        this.createOverlayHighlightSymbolsGrid();
        this.createBottomRowWagons();

        this._resourcesLoaded = true;
        this.gameReady();
    }

    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onInitDataParsed(data: FITHParsedInitData): void {
        this._bonusValues = data.bonusValues;
        this._reels = data.reels;
        this._bottomCollectorActivated = data.bottomCollectorActivated;

        this.gameReady();

        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onGameDataParsed(data: FITHParsedGameData): void {
        this._reels = data.reels;
        this._bonusValues = data.bonusValuesAfterSpin;
        this._bonusNewPositions = data.bonusNewPositions;
        this._dwarfPosition = data.dwarfPosition;
    }

    private createOverlayDSymbolsGrid(): void {
        const startSymId: number = 3,
            baseX: number = 75,
            symWidthBonusGame: number = FITHGameConfig.instance.SYMBOL_WIDTH_BONUS_GAME,
            baseY: number = 458,
            symHeightBonusGame: number = FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME;

        let item: PIXI.Sprite;

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            this._dOverlayItems.push([]);
            for (let j = startSymId; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                item = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures("D2")[0]);
                item.visible = false;
                item.anchor.set(0.5);
                item.position.set(baseX + (i * symWidthBonusGame), baseY + ((j - startSymId) * symHeightBonusGame));
                this.addChild(item);
                this._dOverlayItems[i].push(item);
            }
        }
    }

    private createLandAnimations(): void {
        const baseX: number = 75,
            symWidthBonusGame: number = FITHGameConfig.instance.SYMBOL_WIDTH_BONUS_GAME,
            baseY: number = 198,
            symHeightBonusGame: number = FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME;

        let item: PIXI.spine.Spine;

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            this._landAnimations.push(new PIXI.spine.Spine(new PIXI.spine.core.SkeletonData()));
            for (let j = 1; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                item = new PIXI.spine.Spine(GameResources.getSpineAsset("V_spine"));
                item.visible = false;
                item.position.set(baseX + (i * symWidthBonusGame), baseY + (j * symHeightBonusGame));
                this.addChild(item);
                this._landAnimations.push(item);
            }
            this._landAnimations.push(new PIXI.spine.Spine(new PIXI.spine.core.SkeletonData()));
        }
    }

    private createOverlaySymbolsGrid(): void {
        let item: PIXI.Sprite,
            bgItem: PIXI.Sprite;

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            this._vOverlayBgItems.push(new PIXI.Sprite());
            this._vOverlayItems.push(new PIXI.Sprite());
            for (let j = 1; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                bgItem = new PIXI.Sprite(GameResources.getTextures("vBg")[0]);
                bgItem.visible = false;
                bgItem.blendMode = PIXI.BLEND_MODES.SCREEN;
                bgItem.anchor.set(0.5);
                this._vOverlayBgItems.push(bgItem);

                item = new PIXI.Sprite(FITHGameAssets.getSymbolStateTextures("V")[0]);
                item.name = "coin";
                item.visible = false;
                item.anchor.set(0.5);
                this._vOverlayItems.push(item);

                this.addChild(bgItem, item);
            }
            this._vOverlayBgItems.push(new PIXI.Sprite());
            this._vOverlayItems.push(new PIXI.Sprite());
        }
    }

    private createOverlayHighlightSymbolsGrid(): void {
        const layer: ScalableLayer = StageManager.getLayer(FITHGameConfig.instance.LAYERS.HIGHLIGHT_SLOT.name),
            baseX: number = 75,
            symWidthBonusGame: number = FITHGameConfig.instance.SYMBOL_WIDTH_BONUS_GAME,
            baseY: number = 198,
            symHeightBonusGame: number = FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME;

        let item: TimelineSprite;

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            this._vOverlayHighlightItems.push(new TimelineSprite([PIXI.Texture.EMPTY]));
            for (let j = 1; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                item = new TimelineSprite(GameResources.getTextures("highlightSlot"));
                item.hide();
                item.anchor.set(0.5);
                item.blendMode = PIXI.BLEND_MODES.SCREEN;
                item.position.set(baseX + (i * symWidthBonusGame), baseY + (j * symHeightBonusGame));
                layer.addChild(item);
                this._vOverlayHighlightItems.push(item);
            }
            this._vOverlayHighlightItems.push(new TimelineSprite([PIXI.Texture.EMPTY]));
        }
    }

    private createBottomRowWagons(): void {
        const baseX: number = 60,
            symWidthBonusGame: number = (FITHGameConfig.instance.SYMBOL_WIDTH_BONUS_GAME + 6),
            baseY: number = 198,
            yPos: number = (baseY + (5 * FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));

        let item: PIXI.spine.Spine,
            totalMultiItem: BitmapCountUp;

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            item = new PIXI.spine.Spine(GameResources.getSpineAsset("bottomChest"));
            item.visible = false;
            item.position.set(baseX + (i * symWidthBonusGame), yPos);
            totalMultiItem = new BitmapCountUp({
                style: {
                    font: {
                        name: "NumbersFSMulti",
                        size: 22
                    },
                    tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                }
            });
            totalMultiItem.visible = false;
            totalMultiItem.name = "totalMulti";
            totalMultiItem.text = "";
            totalMultiItem.position.set(-4, 10);
            item.addChild(totalMultiItem);
            this._bottomRowWagons.push(item);
            this.addChild(item);
        }
    }

    private show1xOnCoinSymbol(reelId: number, multiplier: string): void {
        const vSym: PIXI.Sprite = this._vOverlayItems[reelId];

        this._landAnimations[reelId].visible = false;

        this.resetVSym(vSym, reelId, (multiplier === "1" ? (GameResources.getTextures(FITHGameAssets.getSymbolStateTexturePath("V") + "_brown")[0]) : FITHGameAssets.getSymbolStateTextures("V")[0]));
        this._vOverlayBgItems[reelId].position.set(vSym.x, vSym.y);
        vSym.name = "coin";

        // #345
        if (this._multiOnCoinApplied[reelId]) {
            return;
        }

        // #221
        if (multiplier !== "1") {
            const vSymLandScreen: TimelineSprite = new TimelineSprite(GameResources.getTextures("vSymLandScreen"));
            vSymLandScreen.name = "vSymLand";
            vSymLandScreen.anchor.set(0.5);
            vSymLandScreen.blendMode = PIXI.BLEND_MODES.SCREEN;
            vSym.addChild(vSymLandScreen);
            vSymLandScreen.playLoop();
        }

        this.removeVSymChildren(vSym);

        const item: BitmapCountUp = FITHBonusGameVSymOverlayView.createMultiplierItem("");
        vSym.addChild(item);
    }

    private turnOffVSymLand(item: PIXI.Sprite): void {
        const vSymLand: TimelineSprite = (item.getChildByName("vSymLand") as TimelineSprite);

        if (vSymLand) {
            vSymLand.stopLoop();
            vSymLand.hide();
            item.removeChild(vSymLand);
        }
    }

    private checkForVBg(multiplierItem: BitmapCountUp, multiValue: number, vSym: PIXI.Sprite, vId: number, texture: PIXI.Texture): void {
        const vBgItem: PIXI.Sprite = this._vOverlayBgItems[vId];
        let baseAlpha: number = 0.25,
            changeFactor: number = 1;
        if (multiValue > 24 && multiValue < 50) {
            changeFactor = 2;
        } else if (multiValue > 49 && multiValue < 200) {
            changeFactor = 3;
        } else if (multiValue > 199) {
            changeFactor = 4;
        }

        if (multiValue > 9) {
            if (vSym.name === "coin") {
                vBgItem.texture = texture;
            }
            vBgItem.position.set(vSym.x, vSym.y);
            vBgItem.alpha = (baseAlpha * changeFactor);
            multiplierItem.fontSize += changeFactor;
            vBgItem.visible = true;
        }

        if (multiValue > 199) {
            let bling: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bling"));
            new SpineTween(bling, 0, "base", -1);
            vSym.addChild(bling);
        }
    }

    private updateBottomRowWagonSkin(item: PIXI.spine.Spine, value: number): void {
        let suffix: string;

        if (value > 1000) {
            suffix = "6";
        } else if (value > 250) {
            suffix = "5";
        } else if (value > 100) {
            suffix = "4";
        } else if (value > 50) {
            suffix = "3";
        } else if (value > 25) {
            suffix = "2";
        } else {
            suffix = "1";
        }

        item.skeleton.setSkin(null);
        item.skeleton.setSkinByName("lv" + suffix);
    }

    private setBottomRowWagonToLv0(wagon: PIXI.spine.Spine, animationName: string, loop: boolean): void {
        wagon.skeleton.setSkin(null);
        wagon.skeleton.setSkinByName("lv0");
        this.updateStateForBottomChestWagon(wagon, animationName, loop);
    }

    private updateStateForBottomChestWagon(wagon: PIXI.spine.Spine, animationName: string, loop: boolean): void {
        wagon.state.clearTracks();
        wagon.skeleton.setToSetupPose();
        wagon.skeleton.setSlotsToSetupPose();
        wagon.state.setEmptyAnimation(0, 0);
        wagon.state.setAnimation(0, animationName, loop);
    }

    private gameReady(): void {
        if (this._resourcesLoaded && this._bonusValues.length > 0) {
            let vSym: PIXI.Sprite,
                reelId: number,
                vScale: number,
                vName: string,
                vTexture: PIXI.Texture,
                vBgTexture: PIXI.Texture,
                multiplier: number,
                multiplierItem: BitmapCountUp;
            for (let i: number = 0; i < this._bonusValues.length; i++) {
                // middle rows
                for (let j: number = 1; j < (this._bonusValues[i].length - 1); j++) {
                    multiplier = this._bonusValues[i][j];
                    reelId = ((i * 6) + j);

                    // #183
                    if (this._reels[reelId][0] === "DW") {
                        FITHGameModuleConfig.bonusGameSpinNWagonAnimations.initGameDwarf(i, reelId, multiplier);
                        FITHGameModuleConfig.spinController.disableBonusReel(reelId);
                        continue;
                    }

                    if (multiplier > 0) {
                        vSym = this._vOverlayItems[reelId];
                        multiplierItem = FITHBonusGameVSymOverlayView.createMultiplierItem(multiplier + "x");

                        if (this._reels[reelId][0] === "G") {
                            vScale = 0.9;
                            vName = "notCoin";
                            vTexture = GameResources.getTextures("g2Open")[0];
                            vBgTexture = GameResources.getTextures("gBg")[0];
                        } else if (this._reels[reelId][0] === "R1") {
                            vScale = 0.9;
                            vName = "notCoin";
                            vTexture = GameResources.getTextures("rBag")[0];
                            vBgTexture = GameResources.getTextures("rBg")[0];
                        } else {
                            vScale = 0.8;
                            vName = "coin";
                            // #199
                            vTexture = (multiplier === 1 ? (GameResources.getTextures(FITHGameAssets.getSymbolStateTexturePath("V") + "_brown")[0]) : (FITHGameAssets.getSymbolStateTextures("V")[0]));
                            vBgTexture = GameResources.getTextures("vBg")[0];
                        }
                        this.resetVSym(vSym, reelId, vTexture);
                        this.removeVSymChildren(vSym);
                        this.checkForVBg(multiplierItem, multiplier, vSym, reelId, vBgTexture);

                        vSym.name = vName;
                        vSym.scale.set(vScale);
                        vSym.addChild(multiplierItem);

                        FITHGameModuleConfig.spinController.disableBonusReel(reelId);
                    }
                }
            }

            this._resourcesLoaded = false;
            this._reels = [];
        }
    }

    // #304
    private playFSCoinLandingMostValuable(): void {
        let maxLandingValuePerReelPrevious: number = 0,
            maxLandingValuePerReel: number = 0;

        for (let i: number = 0; i < this._bonusNewPositions.length; i++) {
            // new coin can land only in middle 4 rows.
            for (let j: number = 1; j < this._bonusNewPositions[i].length - 1; j++) {
                if (this._bonusNewPositions[i][j]) {
                    maxLandingValuePerReelPrevious = this.calculateLandingValueDifference(i);
                    if (maxLandingValuePerReelPrevious > maxLandingValuePerReel) {
                        maxLandingValuePerReel = maxLandingValuePerReelPrevious;
                    }
                }
            }
        }

        FITHBonusGameVSymOverlayView.playFSCoinLandingSound(maxLandingValuePerReel);
    }

    // #304
    private calculateLandingValueDifference(wagonId: number): number {
        const beforeValues: number[] = this._bonusValuesBeforeSpin[wagonId],
            afterValues: number[] = this._bonusValues[wagonId],
            dwarfPosition: number[] = this._dwarfPosition;
        let totalBeforeValue = 0,
            totalAfterValue = 0;

        for (let i: number = 1; i < beforeValues.length - 1; i++) {
            if (wagonId !== dwarfPosition[0] || i !== dwarfPosition[1]) {
                totalBeforeValue += beforeValues[i];
            }
        }
        for (let i: number = 1; i < afterValues.length - 1; i++) {
            if (wagonId !== dwarfPosition[0] || i !== dwarfPosition[1]) {
                totalAfterValue += afterValues[i];
            }
        }

        return (totalAfterValue - totalBeforeValue);
    }
}
